clickChat();


function clickChat() {
  const event = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  const b = document.querySelector("[href='#live-chat']");
  if (b) {
      b.addEventListener('click', function() {
        const check = document.getElementById('ShopifyChat');
        const cb = document.getElementById('dummy-chat-button-iframe');
        if (check) {
          check.contentWindow.document.querySelector('[aria-controls="chat-ui"]').dispatchEvent(event);
        } else if (cb) {
          cb.contentWindow.document.querySelector('.chat-toggle').dispatchEvent(event);
        }
      })
    }
  }

  window.addEventListener('click', function(evt) {

    // lang switcher
      if (evt.target.id === 'langSwitcher') {
        const langPopover = evt.target.nextElementSibling;
        langPopover.classList.toggle('active');
      } else {
        const langPopover = evt.target.nextElementSibling;
        langPopover.classList.remove('active');
      }

  })